<template>
  <b-row>
    <b-col>
      <b-card>
        <template #header>
          <strong>收支統計表</strong>
        </template>
        <b-row>
          <b-col md="4"> <date-picker v-model="month" type="month" valueType="format" @change="changeMonth" /></b-col>
          <b-col md="4" class="text-center h2">{{ title }}收支表</b-col>
          <b-col md="4" class="text-right"> </b-col>
        </b-row>
        <hr />
        <b-row class="p-3">
          <b-col sm="6" v-for="item in datalist" :key="item.name">
            <small class="text-muted h5"> {{ item.name }} </small>
            <div class="h1 font-weight-bold mb-3 text-primary" v-if="item.total > 0">{{ formatTotal(item.total) }}</div>
            <div class="h1 font-weight-bold mb-3 text-danger" v-else-if="item.total < 0">{{ formatTotal(item.total) }}</div>
            <div class="h1 font-weight-bold mb-3" v-else>{{ formatTotal(item.total) }}</div>
          </b-col>
        </b-row>
        <hr />
        <b-row class="p-3">
          <b-col sm="6">
            <small class="text-muted h5"> 月收入 </small>
            <div class="h1 font-weight-bold mb-3 text-primary">{{ formatTotal(incomeTotal) }}</div>
          </b-col>
          <b-col sm="6">
            <small class="text-muted h5"> 月開銷 </small>
            <div class="h1 font-weight-bold mb-3 text-danger">{{ formatTotal(expenditureTotal) }}</div>
          </b-col>
          <b-col offset-sm="6" sm="6">
            <small class="text-muted h5"> 月損益 </small>
            <div class="h1 font-weight-bold mb-3">{{ formatTotal(total) }}</div>
          </b-col>
        </b-row>
        <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" no-wrap> </b-overlay>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/zh-tw";
export default {
  name: "StatisticePage",
  components: { DatePicker },
  data: () => ({
    loading: false,
    month: "",
    datalist: [],
  }),
  computed: {
    title() {
      let year = this.$date(this.month).format("YYYY");
      let month = this.$date(this.month).format("M");
      return year + "年" + month + "月";
    },
    incomeTotal() {
      return this.datalist
        .filter((p) => p.total > 0)
        .map((p) => p.total)
        .reduce((a, b) => a + b, 0);
    },
    expenditureTotal() {
      return this.datalist
        .filter((p) => p.total < 0)
        .map((p) => Math.abs(p.total))
        .reduce((a, b) => a + b, 0);
    },
    total() {
      return this.incomeTotal - this.expenditureTotal;
    },
  },
  mounted() {
    this.month = this.$date().format("YYYY-MM");
    this.changeMonth();
  },
  methods: {
    changeMonth() {
      let start = this.$date(this.month).format();
      let end = this.$date(this.month).endOf("month").format();
      this.loading = true;
      let params = {
        params: {
          start: start,
          end: end,
        },
      };
      this.$http.get("/asset/statistics", params).then((response) => {
        if (response.data.success) {
          this.datalist = response.data.result;
        } else {
          this.$notify({ type: "error", text: response.data.message });
        }
        this.loading = false;
      });
    },
    formatTotal(val) {
      return this.$function.priceformat(Math.abs(val));
    },
  },
};
</script>